/*
 * Copyright 2026 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const LIST_BLOCK_TYPES = ['unordered-list-item', 'ordered-list-item'];

// Draft depth is zero-based. A maximum depth of 3 allows the root list plus
// three nested levels while keeping pasted and keyboard-created lists bounded.
export const MAX_LIST_DEPTH = 3;
